import { useContext, useEffect, useRef } from "react";
import { ChatContext } from "../../contexts/ChatContext";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import SmartToyIcon from "@mui/icons-material/SmartToy";

export default function ChatMessages() {
  const { messages, isLoading } = useContext(ChatContext);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  if (messages.length === 0 && !isLoading) {
    return (
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 3,
          gap: 2,
          color: "text.secondary",
        }}
      >
        <SmartToyIcon sx={{ fontSize: 48, opacity: 0.5 }} />
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
          }}
        >
          Hi! I'm the Uniform Portal Support Assistant.
          <br />
          Ask me anything about using the portal.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
      {messages.map((msg, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
            mb: 1.5,
          }}
        >
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              maxWidth: "80%",
              bgcolor:
                msg.role === "user" ? "primary.main" : "background.paper",
              color:
                msg.role === "user" ? "primary.contrastText" : "text.primary",
              borderRadius: 2,
              borderTopRightRadius: msg.role === "user" ? 0 : 16,
              borderTopLeftRadius: msg.role === "assistant" ? 0 : 16,
            }}
          >
            <Typography
              variant="body2"
              sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
            >
              {msg.content}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                mt: 0.5,
                opacity: 0.7,
                textAlign: msg.role === "user" ? "right" : "left",
              }}
            >
              {new Date(msg.timestamp).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Typography>
          </Paper>
        </Box>
      ))}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 1.5 }}>
          <Paper
            elevation={1}
            sx={{
              p: 1.5,
              bgcolor: "background.paper",
              borderRadius: 2,
              borderTopLeftRadius: 0,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <CircularProgress size={16} />
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
              }}
            >
              Thinking…
            </Typography>
          </Paper>
        </Box>
      )}
      <div ref={bottomRef} />
    </Box>
  );
}
